import { render, staticRenderFns } from "./PatientAvatar.vue?vue&type=template&id=0608cdab&scoped=true"
import script from "./PatientAvatar.vue?vue&type=script&lang=js"
export * from "./PatientAvatar.vue?vue&type=script&lang=js"
import style0 from "./PatientAvatar.vue?vue&type=style&index=0&id=0608cdab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0608cdab",
  null
  
)

export default component.exports